
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import functionUncurryThis from './function-uncurry-this.js';
import fails$1 from './fails.js';
import classofRaw from './classof-raw.js';

var uncurryThis = functionUncurryThis;
var fails = fails$1;
var classof = classofRaw;

var $Object = Object;
var split = uncurryThis(''.split);

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var indexedObject = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !$Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof(it) === 'String' ? split(it, '') : $Object(it);
} : $Object;

export { indexedObject as default };
//# sourceMappingURL=indexed-object.js.map
